/* eslint-disable class-methods-use-this */
import EventClass from "common/utils/ui/event-class";

class MagnifierMouseOutHandler extends EventClass {
  #$imageBox = undefined;

  get #$magnified() {
    return this.#$imageBox.querySelector(".js-magnify-preview");
  }

  get #$lens() {
    return this.#$imageBox.querySelector(".js-magnify-lens");
  }

  constructor(props) {
    super(props);
    this.#$imageBox = document.querySelector(props.eventSelector);
  }

  /**
   * @returns void
   * @override EventClass.event
   * @description This method is called when the mouse moved out of the image.
   */
  event() {
    this.#$magnified.style.display = "none";
    this.#$lens.style.display = "none";
  }
}

export default props => new MagnifierMouseOutHandler({ event: "mouseout", ...props });
